var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.width < 768)?_c('div',[_c('img',{staticClass:"logo",attrs:{"id":"logo","src":require("@/assets/images/alpha_black.png")},on:{"click":function($event){return _vm.setIsModalVisible(true)}}})]):_c('DefaultActions')}
var staticRenderFns = []

export { render, staticRenderFns }